<div class="w-343 tablet:w-768 laptop:w-912 tablet:px-6">
  <div class="referee-card flex justify-between align-center grid grid-cols-1 pr-7 pl-3 py-7 w-full">
    <div class="grid grid-cols-1 tablet:grid-cols-2">
      <div class="flex items-center pr-1">
        <div class="initial-circle m-2 w-32 h-32">
          <p class="initial-circle-inner text-center align-middle w-32 h-32">R{{refereeNumber}}</p>
        </div>
        <div class="flex flex-col justify-center ml-1">
          <ng-content></ng-content>
          <ng-content select="[reference-type]"></ng-content>
        </div>
      </div>
      <div class="button-holder flex justify-start tablet:justify-self-end pt-4 tablet:pt-0">
        <button class="primary rounded text-light text-3 flex items-center justify-center w-150 h-44" (click)="onAddDetails()">Add details</button>
      </div>
    </div>
  </div>
</div>
